import { getWebAutoInstrumentations } from '@opentelemetry/auto-instrumentations-web';
import { ZoneContextManager } from '@opentelemetry/context-zone';
import { W3CTraceContextPropagator } from '@opentelemetry/core';
import { OTLPTraceExporter } from '@opentelemetry/exporter-trace-otlp-http';
import { registerInstrumentations } from '@opentelemetry/instrumentation';
// @ts-ignore wrong type definition
import { resourceFromAttributes } from '@opentelemetry/resources';
import { BatchSpanProcessor, WebTracerProvider } from '@opentelemetry/sdk-trace-web';
import { ATTR_SERVICE_NAME, ATTR_SERVICE_VERSION } from '@opentelemetry/semantic-conventions';

export function initClientSideOtel(serviceName: string, url: string, version?: string, session?: string) {
    const provider = new WebTracerProvider({
        resource: resourceFromAttributes({
            [ATTR_SERVICE_NAME]: serviceName,
            [ATTR_SERVICE_VERSION]: version || 'unknown',
            session_id: session || 'unknown'
        }),

        spanProcessors: [ new BatchSpanProcessor(new OTLPTraceExporter({ url })) ]
    });

    provider.register({
        contextManager: new ZoneContextManager(),
        propagator: new W3CTraceContextPropagator()
    });

    registerInstrumentations({
        instrumentations: [ getWebAutoInstrumentations({
            // load custom configuration for xml-http-request instrumentation
            '@opentelemetry/instrumentation-xml-http-request': {
                clearTimingResources: true,
                ignoreUrls: [ /\/api\/event/, /\/__manifest/, /\/telemetry/ ]
            },
            '@opentelemetry/instrumentation-fetch': {
                clearTimingResources: true,
                ignoreUrls: [ /\/api\/event/, /\/__manifest/, /\/telemetry/ ]
            }
        }) ]
    });
}
